(function ($) {
	'use strict';

	/*
	 * Menu do usuário Fechar e Abrir
	 */
	$(document).on('click', function (e) {
		var $container = $('.menu-usuario-box');
		var $link = $('.menu-usuario-abrir');
        
		// Verifica se é no container que foi clicado
		if (!$container.is(e.target) &&
			// Verifica se foi clicado em um caontainer descendente
			$container.has(e.target).length === 0 ||
			// Verifica se foi clicado em um link descendente
			$link.has(e.target).length === 1) {

			if ($container.is(':visible')) {
				$container.fadeOut(100);
			} else {
				if ($(e.target).parents('a').is($link)) {
					$container.fadeIn(100);
				}
			}
		}

	});

}(jQuery));